import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import BreadcrumbV2 from './BreadcrumbV2.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header/Header.vue'
import Sidebar from './Sidebar/Sidebar.vue'
import Switch from './Switch.vue'
import Localizer from './Localizer.vue'
import OverviewCard from './OverviewCard.vue'
import ButtonSubmit from './ButtonSubmit.vue'
import DDatasetHeader from './DatasetHeader.vue'
import DatasetHeaderV2 from './DatasetHeaderV2.vue'
import MenuHeader from './MenuHeader.vue'
import SCommandHeader from './CommandHeader.vue'
import Notify from './Notify.vue'
import Notifications from './Notifications.vue'

const cSwitch = Switch

export {
	Aside,
	Breadcrumb,
	Callout,
	Footer,
	Header,
	Sidebar,
	Switch,
	Localizer,
	OverviewCard,
	cSwitch,
	ButtonSubmit,
	DDatasetHeader,
	SCommandHeader,
	BreadcrumbV2,
	DatasetHeaderV2,
	Notify,
	Notifications,
	MenuHeader,
}
